export const addBankDetailsUrl ='/clapply/action/customizeOffer/addBankDetails';
